/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spare_Stale_Sawfish_ResideInputs */

const fr_spare_stale_sawfish_reside = /** @type {(inputs: Spare_Stale_Sawfish_ResideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tendance sur 12 semaines`)
};

/**

* @param {Spare_Stale_Sawfish_ResideInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const spare_stale_sawfish_reside = /** @type {((inputs?: Spare_Stale_Sawfish_ResideInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spare_Stale_Sawfish_ResideInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_spare_stale_sawfish_reside(inputs)
});